import { Card, DatePicker } from 'antd'
import getTemplateDashboardStats from 'api/dashboard/getTemplateDashboardStats'
import { Moment } from 'moment'
import React, { useEffect, useState } from 'react'
import { RangeValue } from 'rc-picker/lib/interface'
import toTileCase from 'utils/toTitleCase'
import { Column } from '@ant-design/plots'
import style from './style.module.scss'

interface PropType {
	clientId?: string
}
interface TemplateStatistic {
	title: string
	value: number
	key: string
}

const TemplateStatsCard: React.FC<PropType> = ({ clientId }) => {
	const [stats, setStats] = useState<TemplateStatistic[]>([])
	const [dateRange, setDateRange] = useState<RangeValue<Moment>>(null)
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		const fetchTemplateStats = async () => {
			setLoading(true)
			try {
				const response = await getTemplateDashboardStats({
					startDate: dateRange?.[0]?.startOf('D').toJSON(),
					endDate: dateRange?.[1]?.endOf('D').toJSON(),
					client: clientId,
				})

				const data = Object.entries(response).map(d => ({
					title: toTileCase(d[0]),
					value: d[1],
					key: d[0],
				}))

				setStats(data)
				setLoading(false)
			} catch {
				setLoading(false)
			}
		}
		fetchTemplateStats()
	}, [clientId, dateRange])
	return (
		<Card className={style.layout} title='Template Stats'>
			<DatePicker.RangePicker
				bordered
				format='YYYY-MM-DD'
				onChange={setDateRange}
				disabledDate={current => {
					// Can not select Date after today
					return current.valueOf() > Date.now()
				}}
				disabled={loading}
			/>
			<div className={style.position}>
				<Column
					data={stats}
					xField='title'
					yField='value'
					xAxis={{ label: { autoHide: false, autoRotate: false } }}
					meta={{
						title: { alias: 'Template Status' },
						value: { alias: 'Template Count' },
					}}
					loading={loading}
				/>
			</div>
		</Card>
	)
}

TemplateStatsCard.defaultProps = {
	clientId: undefined,
}

export default TemplateStatsCard
